import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Assets } from '../assets';
import { emojiKeyToAltText, emojiKeyToImageMap } from './map';

export enum EmojiSize {
  SMALL = 'small',
  LARGE = 'large',
}

@Component({
  selector: 'fl-emoji',
  template: `
    <img
      class="EmojiIcon"
      [attr.data-size]="size"
      [src]="src"
      [alt]="altText"
    />
  `,
  styleUrls: ['./emoji.component.scss'],
})
export class EmojiComponent implements OnChanges {
  EmojiSize = EmojiSize;
  emojiKeyToImageMap = emojiKeyToImageMap;

  @Input() emoji: string;

  @Input() size: EmojiSize = EmojiSize.SMALL;

  src: string;
  altText: string;

  constructor(private assets: Assets) {}

  ngOnChanges(changes: SimpleChanges) {
    if ('emoji' in changes) {
      this.src = this.assets.getUrl(`emoji/${emojiKeyToImageMap[this.emoji]}`);
      this.altText = emojiKeyToAltText[this.emoji];
    }
  }
}
